import { InferType } from 'yup';
import { yupObject, yupString } from 'shared/utils/YupUtils';

export const driverFeedbackSchema = yupObject({
  feedback: yupString().trim().required('Feedback is required').max(500),
});

export type DriverFeedbackDTO = InferType<typeof driverFeedbackSchema>;
